import { z } from 'zod';
import { PassLimit } from './PassLimit';

export const LocationActivePasses = z.object({
	location_id: z.number(),
	passes_from: z.number(),
	passes_to: z.number(),
});

export type LocationActivePasses = z.infer<typeof LocationActivePasses>;

export function fromPassLimits(passLimits: PassLimit): LocationActivePasses {
	return {
		location_id: Number(passLimits.id),
		passes_from: passLimits.from_count,
		passes_to: passLimits.to_count,
	};
}
